// extracted by mini-css-extract-plugin
module.exports = {"pagination":"RequestAttachmentsCard_pagination__3B0gx"};